import * as React from "react";
import MaskedInput from "react-text-mask";

interface IProps {
  inputRef: any;
}

const DELIMETER = " ";
const PLACE_HOLDER = `1234${DELIMETER}5678${DELIMETER}3456${DELIMETER}6789`;
const PLACE_HOLDER_CHAR = "\u2000";

// Note - I read somewhere that a card number cannot have more than 19 digits.
export const CreaditCardMaskedInput: React.SFC<IProps> = ({
  inputRef,
  ...other
}: IProps) => (
  <MaskedInput
    {...other}
    ref={inputRef}
    mask={[
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      DELIMETER,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      DELIMETER,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      DELIMETER,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      DELIMETER,
      /\d/,
      /\d/,
      /\d/
    ]}
    placeholder={PLACE_HOLDER}
    placeholderChar={PLACE_HOLDER_CHAR}
  />
);



// WEBPACK FOOTER //
// ./src/components/Payments/CardPaymentForm/components/CreaditCardMaskedInput.tsx